module.exports = "pegasus/assets/blocks/image-4-basic.png";